import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    // Structure: { [courseId]: { completionRate: number, completedContents: string[], modules: string[] } }
    courseProgressMap: {}
};

const progressSlice = createSlice({
    name: 'progressSlice',
    initialState,
    reducers: {
        setCourseProgress: (state, action) => {
            const { courseId, completionRate, completedContents, modules } = action.payload;
            if (courseId) {
                state.courseProgressMap[courseId] = {
                    completionRate: Math.min(100, Math.max(0, Math.floor(completionRate || 0))),
                    completedContents: completedContents || [],
                    modules: modules || []
                };
            }
        }
    }
});

export const { setCourseProgress } = progressSlice.actions;
export default progressSlice.reducer;
